import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Button } from "@ts-digital/vrc";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Badge, Form, Input, Radio, Select } from "antd";
import moment from "moment";
import { saveClassification } from "../../store/actions/documents/classification";
import { VaporDatePicker } from "../vapor";
import { FormattedMessage } from "react-intl";
import { useIntl } from "react-intl";

const FormItem = Form.Item;
const Option = Select.Option;
const RadioGroup = Radio.Group;

const TagsBlock = props => {
  const {
    documentId,
    etichettePersonalizzate,
    removeEtichettePersonalizzata,
    setEtichettePersonalizzate,
    setStandardTags,
    standardTags,
    isSubmit,
    setIsSubmit,
    dataPayload,
    setDataPayload
  } = props;
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const tags = useSelector(state => state.tags);

  const [etichettaCustom, setEtichettaCustom] = useState(null);

  const intl = useIntl();

  const onSubmit = () => {
    dispatch(saveClassification(documentId,
      dataPayload));
    setIsSubmit(false);
    setDataPayload(null);
  };

  // per assegnare i value iniziali
  useEffect(() => {
    if (tags.list.length === 0) return;
    standardTags.forEach(item => {
      let defaultVal = item.value;

      /* devo capire se ho una data e allora andare a prendere il moment */
      const currentTagsForSchema = tags.list.find(el => el.name === item.key);
      if (
        currentTagsForSchema &&
        currentTagsForSchema.jsonSchema["type"] === "string" &&
        currentTagsForSchema.jsonSchema.hasOwnProperty("format") &&
        currentTagsForSchema.jsonSchema["format"] === "date"
      ) {
        defaultVal = moment(item.value);
      }

      form.setFieldsValue({
        [item.key]: defaultVal
      });
    });
  }, [tags]);

  /** Per validare */
  useEffect(() => {
    if (!isSubmit) return;
    form
      .validateFields()
      .then(values => {
        onSubmit();
      })
      .catch(errorInfo => {
        // diamo il focus al primo elemento con classe ant-form-item-has-error
        const firstError = document.getElementsByClassName("ant-form-item-has-error")[0];
        firstError.scrollIntoView();
      });
  }, [dataPayload, isSubmit]);

  const renderInputText = item => {
    return (
      <Input
        placeholder={`${intl.formatMessage({id: "actions.insert"})} ${item.label}`}
        onChange={e => {
          onChangeStandardTags(item.name, e.target.value);
        }}
      />
    );
  };
  const renderRadioButton = (nameItem, valueItems) => {
    return (
      <RadioGroup
        onChange={e => {
          onChangeStandardTags(nameItem, e.target.value);
        }}
      >
        {valueItems.map((item, key) => (
          <Radio key={"radio_" + nameItem + "_" + key} value={item}>
            {item}
          </Radio>
        ))}
      </RadioGroup>
    );
  };
  const renderSelect = (nameItem, valueItems) => {
    return (
      <Select
        style={{ width: "100%" }}
        onChange={value => {
          onChangeStandardTags(nameItem, value);
        }}
      >
        {valueItems.map((item, key) => (
          <Option key={nameItem + "_" + key} value={item}>
            {item}
          </Option>
        ))}
      </Select>
    );
  };
  const renderDatePicker = nameItem => {
    return (
      <VaporDatePicker
        getPopupContainer={(trigger) => trigger.parentNode}
        onChange={(date, dateValue) => {
          onChangeStandardTags(
            nameItem, dateValue, date
          );
        }}
      />
    );
  };

  const getTypeForm = item => {
    if (
      item.jsonSchema["type"] === "string" &&
      item.jsonSchema.hasOwnProperty("format") &&
      item.jsonSchema["format"] === "date"
    ) {
      return renderDatePicker(item.name);
    } else if (
      item.jsonSchema["type"] === "string" &&
      item.jsonSchema.hasOwnProperty("enum")
    ) {
      if (item.jsonSchema["enum"].length > 4) {
        return renderSelect(item.name, item.jsonSchema["enum"]);
      } 
      return renderRadioButton(item.name, item.jsonSchema["enum"]);
      
    } 
    return renderInputText(item);
    
  };

  /**
   *
   * @param {*} nameItem
   * @param {*} value
   * @param {*} date : optional only for datepicker
   */
  const onChangeStandardTags = (
    nameItem, value, date
  ) => {
    let cloneStandardTags = [...standardTags];

    const existingTag = standardTags.find(el => el.key === nameItem);
    if (existingTag) {
      existingTag.value = value;
    } else {
      cloneStandardTags.push({
        key: nameItem,
        value: value,
        date: date
      });
    }

    form.setFieldsValue({
      [nameItem]: date ? date : value
    });
    setStandardTags(cloneStandardTags);
  };

  const renderLoading = () => {
    return tags.status.started ? (
      <div style={{ margin: "0 auto" }}>
        <FontAwesomeIcon
          icon={["far", "circle-notch"]}
          spin
          style={{ color: "#0090d1", fontSize: "32px" }}
        />
      </div>
    ) : null;
  };

  const renderClosedBadge = (
    label, onClose, classColor
  ) => {
    return (
      <Badge
        className={"badge-label ant-badge-status " + classColor}
        key={"badge" + label}
        status="default"
        style={{ whiteSpace: "normal" }}
        text={
          <div
            style={{
              display: "inline-block",
              wordBreak: "break-all",
              paddingRight: "12px"
            }}
          >
            <FontAwesomeIcon
              icon={["fas", "times-circle"]}
              onClick={onClose.bind(this)}
              style={{ marginRight: "8px", cursor: "pointer" }}
            />
            {label}
          </div>
        }
      />
    );
  };
  const removeEtichettaStandard = item => {
    let standardTagsClone = [...standardTags];
    standardTagsClone = standardTagsClone.filter(el => el.key !== item);
    form.setFieldsValue({
      [item]: null
    });
    setStandardTags(standardTagsClone);
  };

  const renderEtichettaStandardTags = () => {
    const cloneTags = [...standardTags];
    if (cloneTags) {
      let arrayEtichetteStandard = [];
      cloneTags.forEach(function(item) {
        let filterByItem = tags.list.filter(el => {
          return el.name === item.key;
        });
        if (filterByItem.length > 0) {
          let labelTag = filterByItem[0].label;

          arrayEtichetteStandard.push(renderClosedBadge(
            labelTag + " : " + item.value,
            () => {
              removeEtichettaStandard(item.key);
            },
            "labelGreen"
          ));
        }
      });
      return (
        <div className="badge" style={{}}>
          {arrayEtichetteStandard}
        </div>
      );
    }
    return null;
  };

  const addCustomLabel = () => {
    if (etichettePersonalizzate.includes(etichettaCustom)) return;
    const cloneEtichette = [...etichettePersonalizzate];
    cloneEtichette.push(etichettaCustom);
    setEtichettePersonalizzate(cloneEtichette);
  };

  const renderEtichettaPersonalizzata = () => {
    return (
      <FormItem
        label={<FormattedMessage id="documents.classificator.tags.custom" />}
        layout="inline"
        style={{
          width: "calc(100% - 20px)",
          display: "inline-block"
        }}
        className="titleChip"
      >
        <Input
          className="inputAdd"
          placeholder={intl.formatMessage({id: "documents.classificator.tags.newName"})}
          onChange={e => {
            setEtichettaCustom(e.target.value);
          }}
          onKeyPress={e => {
            if (e.charCode === 13) {
              addCustomLabel();
            }
          }}
        />
        <Button onClick={e => addCustomLabel()} className="buttonAdd">
          <FormattedMessage id="actions.add" />
        </Button>
      </FormItem>
    );
  };

  const renderStandardTags = () => {
    if (!tags.list || tags.list.length === 0) return undefined;

    let arrayHTML = [];
    tags.list.map(el => {
      let typeItemForm = null;
      typeItemForm = getTypeForm(el);

      arrayHTML.push(<FormItem
        name={el.name}
        key={"tagitem_" + el.name}
        label={el.label}
        layout="inline"
        style={{
          margin: "4px 20px 4px 0",
          flex: "1 0 auto"
        }}
        className="dbx-documents-classificator"
        rules={[{ required: el.required, message: "Campo Obbligatorio!" }]}
      >
        {typeItemForm}
      </FormItem>);
      return arrayHTML;
    });

    return (
      <Form form={form} initialValues={tags.list} onFinish={onSubmit}>
        <div
          style={{ display: "flex", flexDirection: "row", flexWrap: "wrap" }}
        >
          {arrayHTML}
        </div>
      </Form>
    );
  };

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <h2 className="subtitleSection" style={{ marginTop: "10px" }}>
        <FormattedMessage id="documents.classificator.tags.add" />
      </h2>
      {renderLoading()}
      <div>
        {renderStandardTags()}
        {renderEtichettaStandardTags()}
        <div style={{ marginBottom: "8px" }}>
          {renderEtichettaPersonalizzata()}
        </div>
        <div className="badge" style={{}}>
          {etichettePersonalizzate.map((item, key) =>
            renderClosedBadge(
              item,
              () => {
                removeEtichettePersonalizzata(item);
              },
              "labelFucsia"
            ))}
        </div>
      </div>
    </div>
  );
};
export default TagsBlock;
